import { toast } from 'react-hot-toast';

/**
 * Handle API errors and display appropriate notifications
 * @param {Error} error - The error object from axios
 * @param {string} defaultMessage - Default message to show if no specific error is found
 */
export const handleApiError = (error, defaultMessage = 'An error occurred. Please try again.') => {
  console.error('API Error:', error);

  // Check if it's an axios error with response data
  if (error.response && error.response.data) {
    const { data } = error.response;

    // Handle validation errors (Laravel typically returns these as errors object)
    if (data.errors) {
      // Get all validation error messages and join them
      const validationErrors = Object.values(data.errors)
        .flat()
        .join('\n');

      toast.error(validationErrors || data.message || defaultMessage);
      return;
    }

    // Handle message in response data
    if (data.message) {
      toast.error(data.message);
      return;
    }
  }

  // Handle network errors
  if (error.message === 'Network Error') {
    toast.error('Network error. Please check your connection.');
    return;
  }

  // Default error message
  toast.error(defaultMessage);
};

/**
 * Format validation errors from Laravel into a readable object
 * @param {Object} errors - Laravel validation errors object
 * @returns {Object} Formatted errors object
 */
export const formatValidationErrors = (errors) => {
  if (!errors) return {};

  return Object.keys(errors).reduce((acc, field) => {
    acc[field] = errors[field][0]; // Take the first error message for each field
    return acc;
  }, {});
};
